export default __webpack_public_path__ + "static/media/search-bg-1.e5f0dae6.png";